import React from 'react';
import TextField from "../../Forms/TextField";

const BasicTextFields = ({ fields }) => {
  return (
    <>
      {fields.map((field) => (
        <TextField key={field.name} {...field} />
      ))}
    </>
  );
};

export default BasicTextFields;
